// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-page .container{width:calc(100% - 60px)}.error-page--image{display:block;margin:50px auto 0}.error-page--title{font-weight:700;font-size:24px;line-height:32px;color:#13100d;display:block;margin:40px 0 30px}.error-page--text{font-size:16px;font-weight:400;color:#13100d;margin-bottom:40px}.error-page--text a{color:#0d6efd}.error404 em{font-weight:700;font-style:normal}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
